/**
 * Sem tela própria: quando o professor está no portal DENTRO do aplicativo 2.0.5+, confere se há sala com resultado
 * guardado e credencial vencida, renova e o aplicativo envia (`renovarCredenciaisDasSalas`, aplicativo.ts). Avisa num
 * aviso curto. Fora do aplicativo, ou com outro papel, não faz nada.
 */
import { useEffect, useRef } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useToast } from '@/components/common/Toast';
import { renovarCredenciaisDasSalas } from './aplicativo';

export function RenovarCredenciaisDasSalas() {
  const { user, isAuthenticated } = useAuth();
  const toast = useToast();
  const feito = useRef(false);
  const papel = (user as { role?: string } | null)?.role;
  useEffect(() => {
    if (feito.current || !isAuthenticated || !['TEACHER', 'SCHOOL_STAFF', 'ADMIN'].includes(String(papel))) return;
    if (typeof window === 'undefined' || !window.portalSimulados?.salasSemCredencial) return;
    feito.current = true;
    renovarCredenciaisDasSalas().then(({ renovadas, falhas }) => {
      if (renovadas.length) toast.success(`Envio da sala sem internet liberado: ${renovadas.join(', ')}. A janela da sala mostra quando os resultados chegarem ao portal.`);
      if (falhas.length) toast.error(`Não foi possível liberar o envio de: ${falhas.join(', ')}. Tente de novo mais tarde.`);
    }).catch(() => { feito.current = false; });
  }, [isAuthenticated, papel, toast]);
  return null;
}
